var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-item',[_c('q-item-section',{attrs:{"avatar":""}},[_c('q-icon',{attrs:{"color":_vm.color,"name":_vm.icon}})],1),_c('q-item-section',{staticClass:"text-weight-medium"},[_vm._v(" "+_vm._s(_vm.feature.content)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }